export default __webpack_public_path__ + "static/media/Marino Sinibaldi.d648654d.jpg";